module.exports = __webpack_public_path__ + "img/BTC.c5173436.png";